<template>
  <content-wrapper>
    <Content class="mt-3">
      <b-card header-bg-variant="dark">
        <template #header>
          <b-row class="align-items-center justify-content-between">
            <b-col>
              <h6 class="mb-0">Vehicles</h6>
            </b-col>
            <b-col md="1" v-if="can('superadmin|memberadmin|member')">
              <b-button variant="outline-light" @click="openVehicleModal">
                <b-icon icon="plus-circle-fill"></b-icon>
                Add
              </b-button>
            </b-col>
          </b-row>
        </template>


        <!-- Table Search -->
        <div class="form-group row" v-if="isSuperAdmin">
          <label class="col-sm-2 col-form-label">Select Member</label>
          <div class="col-sm-10 input-group mb-3">
            <MemberDropDown v-model="selectedMember" :member="member" @change="pagination.current =1;$refs.table.refresh()"></MemberDropDown>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Search</label>
          <div class="col-xl-4 mb-3">
            <b-form-select
                v-model="searchForm.type"
                :options="options.search"
            ></b-form-select>
          </div>
          <div class="col-sm-4 mb-3">
            <b-form-input
                placeholder="Keywords"
                v-model="searchForm.keywords"
                @keydown.enter="pagination.current=1;$refs.table.refresh()"
            ></b-form-input>
          </div>
          <div class="col-sm-2 mb-3">
            <b-form-radio-group
                buttons
                button-variant="outline-primary"
                :options="options.status"
                name="radios-btn-direction"
                v-model="searchForm.status"
                @change="pagination.current=1;$refs.table.refresh()"
            >
            </b-form-radio-group>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Expire</label>
          <div class="col-sm-4 mb-3">
            <b-form-datepicker
                id="endDate"
                v-model="searchForm.expire"
                locale="en-US"
                label-no-date-selected="Expire"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            ></b-form-datepicker>
          </div>
          <div class="col-sm-2 mb-3">
            <b-form-radio-group
                buttons
                button-variant="outline-primary"
                :options="options.status"
                name="radios-btn-direction"
                v-model="searchForm.status"
                @change="pagination.current=1;$refs.table.refresh()"
            >
            </b-form-radio-group>
          </div>
        </div>
        <b-row class="mb-3">
          <b-col offset-md="8"></b-col>
          <b-col sm="3">
            <button type="button" class="btn btn-info btn-block" @click="pagination.current=1;$refs.table.refresh()">
              <i class="fa fa-search"></i> Search
            </button>
          </b-col>
        </b-row>

        <!--  TABLE  -->
        <b-table :per-page="pagination.per_page"
                 :current-page="pagination.current"
                 ref="table"
                 id="table"
                 :items="loadPage"
                 :fields="columns"
                 :busy.sync="isLoading"
                 striped
                 borderless
                 outlined
                 hover
                 show-empty
                 responsive
                 empty-text="No records found..."
                 stacked="sm"
                 class="mb-3"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner label="Loading..." type="grow"></b-spinner>
            </div>
          </template>
          <template #cell(license_place)="data">
            {{ data.item.truck.no }}
          </template>
          <template #cell(model_color)="data">
            {{ data.item.brand_model }}
            <b-badge variant="secondary">{{ data.item.paint_color }}</b-badge>
          </template>
          <template #cell(expiry)="data">
            <span v-if="isString(data.item.truck.exp) && ( today.localeCompare(data.item.truck.exp) <= 0 )">
            {{
              data.item.truck.exp !== '' ? data.item.truck.exp : '-'
            }}
            </span>
            <b-badge variant="danger" v-if="isString(data.item.truck.exp) && ( today.localeCompare(data.item.truck.exp)>0)">
              {{data.item.truck.exp}}
            </b-badge>
          </template>
          <template #cell(KIR)="data">
            <span v-if="isString(data.item.kir.exp) && ( today.localeCompare(data.item.kir.exp) <= 0 )">
              {{
                data.item.kir.exp !== '' ? data.item.kir.exp : '-'
              }}
            </span>
            <b-badge variant="danger" v-if="isString(data.item.kir.exp) && ( today.localeCompare(data.item.kir.exp)>0)">
              {{data.item.kir.exp}}
            </b-badge>
          </template>
          <template #cell(STNK)="data">
            <span v-if="isString(data.item.stnk.exp) && ( today.localeCompare(data.item.stnk.exp) <= 0 )">
            {{
              data.item.stnk.exp !== '' ? data.item.stnk.exp : '-'
            }}
            </span>
            <b-badge variant="danger" v-if="isString(data.item.stnk.exp) && ( today.localeCompare(data.item.stnk.exp)>0)">
              {{data.item.stnk.exp}}
            </b-badge>
          </template>
          <template #cell(status)="data">
            <b-badge :variant="status[0][data.value]">
              {{ status[1][data.value] }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
              <b-button squared variant="primary btn-sm" @click="vehicle = data.item; $bvModal.show('vehicleModal'); readOnly=true;">
                View
              </b-button>
              <b-button squared
                  v-if="can('superadmin|gate_pass')"
                  :variant="data.item.status === 1 ? 'danger btn-sm' : 'info btn-sm' "
                  @click="showConfirmationModal(data.item)"
              >{{ data.item.status === 1 ? 'Disable Me' : 'Enable Me'}}</b-button>
          </template>
        </b-table>
        <div class="form-group row justify-content-end">
          <label class="col-sm-1 col-form-label">Per Page</label>
          <div class="col-sm-1 mb-3">
            <b-form-select
                :value="pagination.per_page"
                :options="options.pagination"
                @change="(v) => {pagination.per_page = v; pagination.current = 1}"
            ></b-form-select>
          </div>
          <div class="pr-2">
            <simple-pagination
                v-model="pagination.current"
                :disable-prev="pagination.current === 1"
                :disable-next="pagination.at_last_page"
            />
          </div>
        </div>
      </b-card>
    </Content>

    <!-- EDIT DOCS FORM - modal  -->
    <b-modal
        centered
        id="imgDocModal"
        size="lg"
        header-bg-variant="secondary"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        :title="type[ doc.type ] + ' Document [' + doc.id + ']'">
      <b-row>
        <!--   IMG FILE UPLOAD   -->
        <b-form-group
            :label="'Gambar ' + type[doc.type]"
            label-for="img_file"
            label-class="required"
            description="Clear scan of your document. JPEG or PNG only"
        >
          <b-form-file
              id="img_file"
              v-model="doc.file"
              accept="image/jpeg, image/png"
              :state="doc.file ===null ? null : Boolean(doc.file)"
              :placeholder="'Drop ' + type[doc.type] + ' PICTURE File here...'"
              :drop-placeholder="'Drop ' + type[doc.type] + ' PICTURE File here...'"
          ></b-form-file>
          <b-form-invalid-feedback>
            This is a required field
          </b-form-invalid-feedback>
        </b-form-group>
      </b-row>
      <b-row v-if="doc.type!=2">
        <b-form-group
            :label="type[doc.type] + ' No'"
            label-for="doc_no"
            label-class="required"
        >
          <b-form-input
              id="doc_no"
              v-model="doc.no"
              type="text"
              :state="validateState('editDoc', 'doc.no')"
              v-uppercase
          ></b-form-input>
          <b-form-invalid-feedback>
            This is a required field and must be at least 3 characters.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-row>
      <b-row v-if="doc.type!=2">
        <b-form-group
            :label="'Masa Berlaku ' + type[doc.type]"
            label-for="doc_exp"
            label-class="required"
        >
          <b-form-datepicker
              id="doc_exp"
              v-model="doc.exp"
              locale="en-US"
              :min="(new Date())"
              :state="validateState('editDoc', 'doc.exp')"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
          <b-form-invalid-feedback>
            This is a required field.
          </b-form-invalid-feedback>
        </b-form-group>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="updateDoc();">
          OK!
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="cancel();">
          Forget It!
        </b-button>
      </template>
    </b-modal>

    <!-- ADD MUTATION - modal  -->
    <b-modal
      centered
      id="AddMutationModal"
      size="md"
      header-bg-variant="secondary"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Add Mutation"
    >
      <div class="mb-2">{{ time }}</div>
      <!-- From Member -->
      <b-form-group
        label="From Member"
        label-for="owner_name"
      >
        <b-form-input
          id="owner_name"
          v-if="!readOnly"
          v-model="$v.vehicle.owner_name.$model"
          :state="validateState('vehicle','owner_name')"
          required
          type="text"
          :readonly="readOnly"
          :disabled="readOnly"
          v-uppercase
        ></b-form-input>
        <b-form-input
            id="owner_name"
            v-if="readOnly"
            v-model="vehicle.owner_name"
            type="text"
            :readonly="readOnly"
            :disabled="readOnly"
            v-uppercase
        ></b-form-input>
        <b-form-invalid-feedback>
          This is a required field and must be at least 3 characters.
        </b-form-invalid-feedback>
      </b-form-group>

      <!-- To Member -->
      <b-form-group
        label="To Member"
        label-for="owner_name"
      >
        <MemberDropDown 
          v-model="selectedMember" :member="member" @change="pagination.current =1;$refs.table.refresh()">
        </MemberDropDown>
      </b-form-group>

      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="addMutation();">
          Save
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="cancel();">
          Forget It!
        </b-button>
      </template>
    </b-modal>

    <!-- VEHICLE MUTATION - modal  -->
    <b-modal
      centered
      id="vehicleMutationModal"
      size="lg"
      header-bg-variant="secondary"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Vehicle Mutation List">

      <b-form-group
        label="License Plate"
        label-for="no_pol"
      >
        <b-form-input
          id="no_pol"
          v-if="!readOnly"
          v-model="$v.vehicle.truck.no.$model"
          :state="validateState('vehicle','truck.no')"
          required
          type="text"
          :readonly="readOnly"
          :disabled="readOnly"
          v-uppercase
        ></b-form-input>
        <b-form-input
            id="no_pol"
            v-if="readOnly"
            v-model="vehicle.truck.no"
            type="text"
            :readonly="readOnly"
            :disabled="readOnly"
            v-uppercase
        ></b-form-input>
        <b-form-invalid-feedback>
          This is a required field and must be at least 3 characters.
        </b-form-invalid-feedback>
      </b-form-group>

      <!--  MUTATION TABLE  -->
      <b-table :per-page="pagination.per_page"
        :current-page="pagination.current"
        ref="tableMutation"
        id="tableMutation"
        :items="loadMutation"
        :fields="columns_mutation"
        :busy.sync="isLoading"
        striped
        borderless
        outlined
        hover
        show-empty
        responsive
        empty-text="No records found..."
        stacked="sm"
        class="mb-3">

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner label="Loading..." type="grow"></b-spinner>
          </div>
        </template>
        <template #cell(type)="data">
          <div :class="typeof data.item.ended_at == 'object' ? 'text-primary' : 'text-danger'">
            {{ 
              typeof data.item.ended_at == 'object' ? 
              'active':
                (
                  typeof data.item.ended_at == 'string' ? 
                  'archived':'unregistered'
                ) 
            }}
          </div>
        </template>
        <template #cell(date_start)="data">
          {{ data.item.created_at.split('T')[0] }}
        </template>
        <template #cell(date_end)="data">
          {{ typeof data.item.ended_at == 'string' ? data.item.ended_at.split(' ')[0] : ''}}
        </template>
        <template #cell(curr_own)="data">
          {{ data.item.member_own[0].company_name }}
        </template>
        <template #cell(prev_own)="data">
          {{ data.item.member_end[0].company_name }}
        </template>
        <template #cell(actions)="data">
          <div v-if="data.index == 0" 
            @click="delMutation(data.item)"
            class="cursor-pointer badge badge-sm badge-danger">
            delete
          </div>
        </template>

      </b-table>

      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="$bvModal.show('AddMutationModal');">
          <b-icon icon="plus-circle-fill"></b-icon>
          Add
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="$v.activatedVehicle.$reset();cancel();">
          Forget It!
        </b-button>
      </template>
    </b-modal>

    <!-- VEHICLE FORM - modal  -->
    <b-modal
        centered
        id="vehicleModal"
        size="lg"
        header-bg-variant="secondary"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        title="Vehicle Form">
      <b-row>
        <b-col v-if="isSuperAdmin && !readOnly">
          <b-form-group
              label="Owner"
              label-for="owner_name"
          >
            <MemberDropDown
                @change="setVehicleMember"
                :state="validateState('vehicle','owner_name')"
                error-message="This is a required field"
                :member="member"
            ></MemberDropDown>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="">
        <b-form-group
              label="TRUCK"
              description="Truck Information"
              label-class="rounded bg-primary"
              class="border rounded w-100"
              label-align="center v-center"
        >
          <b-row class="pt-2 px-3">
            <div class="d-flex flex-sm-row flex-column w-100">
              <b-col v-if="readOnly" class="">
                <b-row>
                  <b-link class="w-100" target="_blank" :href="readOnly && typeof vehicle.file_truck === 'string' ? vehicle.file_truck : '#'">
                    <b-img class="w-75" v-if="readOnly && typeof vehicle.file_truck === 'string'" rounded alt="TRUCK" v-bind="image" :src="vehicle.file_truck"></b-img>
                    <b-img class="w-75" v-else rounded alt="TRUCK" v-bind="image" src="https://placehold.co/150"></b-img>
                  </b-link>
                </b-row>
                <b-row align-h="center">
                  <b-button size="sm"
                            v-if="can('superadmin|gate_pass')"
                            :variant="'info'"
                            @click="openImgDocModal(2)"
                  >Edit
                  </b-button>
                </b-row>
              </b-col>
              <b-col class="">
                <b-row>
                  <!--   FOTO TRUCK UPLOAD   -->
                  <b-form-group
                      v-if="!readOnly"
                      label="Photo"
                      label-for="file_truck"
                      label-class="required"
                      description="Clear photo of your Truck. JPEG or PNG only"
                  >
                    <b-form-file
                        v-if="!readOnly"
                        id="file_truck"
                        v-model="file.truck"
                        accept="image/jpeg, image/png"
                        :state="file.truck ===null ? null : Boolean(file.truck)"
                        placeholder="Drop Truck photo here..."
                        drop-placeholder="Drop Truck photo here..."
                    ></b-form-file>
                    <b-form-invalid-feedback>
                      This is a required field
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-form-group
                      label="License Plate"
                      label-for="no_pol"
                  >
                    <b-form-input
                        id="no_pol"
                        v-if="!readOnly"
                        v-model="$v.vehicle.truck.no.$model"
                        :state="validateState('vehicle','truck.no')"
                        required
                        type="text"
                        :readonly="readOnly"
                        :disabled="readOnly"
                        v-uppercase
                    ></b-form-input>
                    <b-form-input
                        id="no_pol"
                        v-if="readOnly"
                        v-model="vehicle.truck.no"
                        type="text"
                        :readonly="readOnly"
                        :disabled="readOnly"
                        v-uppercase
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
                <b-row v-show="readOnly">
                  <b-form-group v-if="readOnly"
                                label="Vehicle Expiry"
                                label-for="vehicle_expiry"
                  >
                    <b-form-input
                        id="vehicle_expiry"
                        v-model="vehicle.truck.exp"
                        type="text"
                        :readonly="true"
                        :disabled="true"
                    ></b-form-input>
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-form-group
                      label="Brand Model"
                      label-for="brand_model"
                  >
                    <b-form-input
                        id="brand_model"
                        v-model="$v.vehicle.brand_model.$model"
                        type="text"
                        :state="validateState('vehicle','brand_model')"
                        :readonly="readOnly"
                        :disabled="readOnly"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-form-group
                      label="Color"
                      label-for="paint_color"
                  >
                    <b-form-input
                        id="paint_color"
                        required
                        v-model="$v.vehicle.paint_color.$model"
                        type="text"
                        :state="validateState('vehicle','paint_color')"
                        :readonly="readOnly"
                        :disabled="readOnly"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
              </b-col>
            </div>
          </b-row>
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group
            label="STNK"
            description="STNK information"
            label-class="rounded bg-primary"
            class="border rounded w-100"
            label-align="center v-center"
        >
          <b-row class="pt-2 px-3">
            <div class="d-flex flex-sm-row flex-column w-100">
              <b-col v-if="readOnly">
                <b-row>
                  <b-link class="w-100" target="_blank" :href="readOnly && typeof vehicle.file_stnk === 'string' ? vehicle.file_stnk : '#'">
                    <b-img class="w-75" v-if="readOnly && typeof vehicle.file_stnk === 'string'" rounded alt="STNK" v-bind="image" :src="vehicle.file_stnk"></b-img>
                    <b-img class="w-75" v-else rounded alt="STNK" v-bind="image" src="https://placehold.co/150"></b-img>
                  </b-link>
                </b-row>
                <b-row align-h="center">
                  <b-button size="sm"
                            v-if="can('superadmin|gate_pass')"
                            :variant="'info'"
                            @click="openImgDocModal(3)"
                  >Edit
                  </b-button>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <!--   STNK UPLOAD   -->
                  <b-form-group
                      v-if="!readOnly"
                      label="Photo"
                      label-for="file_stnk"
                      label-class="required"
                      description="Clear scan of your STNK document. JPEG or PNG only"
                  >
                    <b-form-file
                        v-if="!readOnly"
                        id="file_stnk"
                        v-model="file.stnk"
                        accept="image/jpeg, image/png"
                        :state="file.stnk ===null ? null : Boolean(file.stnk)"
                        placeholder="Drop STNK here..."
                        drop-placeholder="Drop STNK here..."
                    ></b-form-file>
                    <b-form-invalid-feedback>
                      This is a required field
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-form-group
                      label="STNK No"
                      label-for="stnk_no"
                      label-class="required"
                  >
                    <b-form-input
                        id="stnk_no"
                        v-model="$v.vehicle.stnk.no.$model"
                        type="text"
                        :state="validateState('vehicle','stnk.no')"
                        :readonly="readOnly"
                        :disabled="readOnly"
                        v-uppercase
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-form-group
                      label="STNK Expiry Date"
                      label-for="stnk_expiry_date"
                      label-class="required"
                  >
                    <b-form-datepicker
                        id="stnk_expiry_date"
                        v-model="$v.vehicle.stnk.exp.$model"
                        locale="en-US"
                        :readonly="readOnly"
                        :min="(new Date())"
                        :state="validateState('vehicle', 'stnk.exp')"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                    <b-form-invalid-feedback>
                      This is a required field.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
              </b-col>
            </div>
          </b-row>
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group
            label="KIR"
            description="KIR information"
            label-class="rounded bg-primary"
            class="border rounded w-100"
            label-align="center v-center"
        >
          <b-row class="pt-2 px-3">
            <div class="d-flex flex-sm-row flex-column w-100">
              <b-col v-if="readOnly">
                <b-row>
                  <b-link class="w-100" target="_blank" :href="readOnly && typeof vehicle.file_kir === 'string' ? vehicle.file_kir : '#'">
                    <b-img class="w-75" v-if="readOnly && typeof vehicle.file_kir === 'string'" rounded alt="KIR" v-bind="image" :src="vehicle.file_kir"></b-img>
                    <b-img class="w-75" v-else rounded alt="KIR" v-bind="image" src="https://placehold.co/150"></b-img>
                  </b-link>
                </b-row>
                <b-row align-h="center">
                  <b-button size="sm"
                            v-if="can('superadmin|gate_pass')"
                            :variant="'info'"
                            @click="openImgDocModal(4)"
                  >Edit
                  </b-button>
                </b-row>
              </b-col>
              <b-col>
                <b-row>
                  <!--   BUKU KIR UPLOAD   -->
                  <b-form-group
                      v-if="!readOnly"
                      label="Photo"
                      label-for="file_kir"
                      label-class="required"
                      description="Clear scan of your KIR document. JPEG or PNG only"
                  >
                    <b-form-file
                        v-if="!readOnly"
                        id="file_kir"
                        v-model="file.kir"
                        accept="image/jpeg, image/png"
                        :state="file.kir ===null ? null : Boolean(file.kir)"
                        placeholder="Drop KIR here..."
                        drop-placeholder="Drop KIR here..."
                    ></b-form-file>
                    <b-form-invalid-feedback>
                      This is a required field
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-form-group
                      label="KIR No"
                      label-for="kir_no"
                      label-class="required"
                  >
                    <b-form-input
                        id="kir_no"
                        v-model="$v.vehicle.kir.no.$model"
                        type="text"
                        :state="validateState('vehicle','kir.no')"
                        :readonly="readOnly"
                        :disabled="readOnly"
                        v-uppercase
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
                <b-row>
                  <b-form-group
                      label="KIR Expiry Date"
                      label-for="kir_expiry_date"
                      label-class="required"
                  >
                    <b-form-datepicker
                        id="kir_expiry_date"
                        v-model="$v.vehicle.kir.exp.$model"
                        locale="en-US"
                        :readonly="readOnly"
                        :min="(new Date())"
                        :state="validateState('vehicle', 'kir.exp')"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                    <b-form-invalid-feedback>
                      This is a required field.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-row>
              </b-col>
            </div>
          </b-row>
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group
          label="RFID"
          description="RFID information"
          label-class="rounded bg-primary"
          class="border rounded w-100"
          label-align="center v-center"
        >
          <b-row class="pt-2 px-3">
            <div class="d-flex w-100">
              <b-form-input
                  id="tag_no"
                  v-model="vehicle.tag"
                  type="text"
                  :state="validateState('vehicle','tag')"
                  :readonly="btn_register "
                  :disabled="btn_register"
              ></b-form-input>
              <b-button size="sm"
                v-if="can('superadmin|gate_pass')"
                :variant="btn_register ? 'info':'primary'"
                @click="btn_register ? clickSign():$bvModal.show('confirmation-rfid');"
              >{{btn_register ? 'Sign':'Register'}}
              </b-button>
              <b-button size="sm"
                v-show="!btn_register"
                class="ml-2"
                v-if="can('superadmin|gate_pass')"
                :variant="'secondary'"
                @click="cancelSign()"
              >Cancel
              </b-button>
            </div>
          </b-row>
        </b-form-group>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" :disabled="isSubmitting" v-if="!readOnly" @click="submitVehicle()">
          Submit
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="primary" v-if="readOnly"
          @click="
            loadMutation();
            $bvModal.show('vehicleMutationModal');">
          Daftar Mutasi
        </b-button>
        <b-button variant="secondary" @click="clearForm();cancel()">
          Forget it
        </b-button>
      </template>
    </b-modal>

    <!-- Activate Vehicle Modal -->
    <b-modal centered header-bg-variant="success" size="sm"
             id="activate"
             title="Activating Vehicle"
             ok-only
             no-close-on-esc
             hide-header-close
             no-close-on-backdrop>
      <b-form-group
          label="Payment No."
          label-for="PaymentNo"
          label-class="required"
          description="Enter Valid Payment Number"
      >
        <b-form-input
            id="PaymentNo"
            v-model="$v.activatedVehicle.payment_no.$model"
            type="text"
            placeholder="Enter Valid Payment No."
            :state="validateState('activatedVehicle', 'payment_no')"
        ></b-form-input>
        <b-form-invalid-feedback>
          This is a required field.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
          label="Expiry Date"
          label-for="vehicle_expiry_date"
          label-class="required"
      >
        <b-form-datepicker
            id="vehicle_expiry_date"
            v-model="$v.activatedVehicle.expire_date.$model"
            locale="en-US"
            :state="validateState('activatedVehicle', 'expire_date')"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        ></b-form-datepicker>
        <b-form-invalid-feedback>
          This is a required field.
        </b-form-invalid-feedback>
      </b-form-group>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="updateVehicleStatus(activatedVehicle)">
          OK!
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="$v.activatedVehicle.$reset();cancel();">
          Forget It!
        </b-button>
      </template>
    </b-modal>

    <b-modal header-class="bg-danger text-white" id="confirmation">
      <template #modal-title>
        <b-icon icon="exclamation-triangle-fill"></b-icon> Disable Vehicle Confirmation
      </template>
      <h1 class="text-center font-weight-bolder">WARNING!</h1>
      <h4 class="text-center">Are you sure to disable this vehicle?</h4>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="outline-danger" @click="disableVehicle(disabledVehicle)">
          Yes, Disable it!
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button size="sm" variant="secondary" @click="hide('forget')">
          Forget it
        </b-button>
      </template>
    </b-modal>

    <b-modal header-class="bg-danger text-white" id="confirmation-rfid">
      <template #modal-title>
        <b-icon icon="exclamation-triangle-fill"></b-icon> New Register RFID Confirmation
      </template>
      <h1 class="text-center font-weight-bolder">WARNING!</h1>
      <h4 class="text-center">Are you sure to pair this RFID tag?</h4>
      <h4 class="text-center text-danger"><b>{{vehicle.truck.no}}</b></h4>
      <h5 class="text-center"><b>{{vehicle.tag}}</b></h5>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="outline-danger" @click="confirmRfid({no_pol:vehicle.truck.no,tag:vehicle.tag})">
          Sure!
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button size="sm" variant="secondary" @click="hide('forget')">
          Forget it
        </b-button>
      </template>
    </b-modal>
  </content-wrapper>
</template>

<script>
import {addVehicle, listVehicle, activateVehicle, setImgDoc} from "../services/vehicles";
import {validationMixin} from "vuelidate";
import { required, minLength, } from "vuelidate/lib/validators";
import {
  BFormFile,
  BIcon,
  BIconExclamationTriangleFill, BIconPlusCircleFill,
  BImg, BLink,
  BFormDatepicker,
} from "bootstrap-vue";
import MemberDropDown from "@/components/composable/MemberDropDown";
import {userInfoMixin} from "@/mixins/userInfoMixin";
import {formValidation} from "@/mixins/formValidation";
import SimplePagination from "@/components/SimplePagination";
import Str from "@/helpers/Str";
import {uploadImageMixin} from "@/mixins/uploadImageMixin";
import {hasOwnProperty, isString} from "@/helpers/Utils";
import {
  indexMutation, addMutation, delMutation,
  listTag, registerTag
} from "@/services/persero_btm";
export default {
  name: "Vehicles",
  components: {
    SimplePagination,
    BIcon,
    // eslint-disable-next-line vue/no-unused-components
    BIconPlusCircleFill, BIconExclamationTriangleFill,
    MemberDropDown,
    BFormFile,
    BImg, BLink,
    BFormDatepicker,
  },
  mixins: [
    validationMixin,
    userInfoMixin,
    formValidation,
    uploadImageMixin,
  ],
  validations:{
    editDoc: {
      doc: {
        no: {
          required,
          minLength: minLength(3),
        },
        exp: {
          required,
        },
      },
    },
    vehicle: {
      owner_name: {
        required,
        minLength: minLength(5),
      },
      brand_model: {
        required,
        minLength: minLength(3),
      },
      paint_color: {
        required,
        minLength: minLength(3),
      },
      stnk: {
        no: {
          required,
          minLength: minLength(3),
        },
        exp: {
          required,
        },
      },
      kir: {
        no: {
          required,
          minLength: minLength(3),
        },
        exp: {
          required,
        },
      },
      truck: {
        no: {
          required,
          minLength: minLength(3),
        },
      },
    },
    activatedVehicle:{
      payment_no: {
        required,
        minLength: minLength(3),
      },
      expire_date: {
        required,
      },
    }
  },
  data: () => ({
    now: new Date(),
    today: new Date().toISOString().split('T')[0],
    interval:null,
    time:null,
    isSubmitting: false,
    vehicles:[],
    vehicle: {
      member: 0,
      no_pol: "",
      owner_name: "",
      brand_model: "",
      paint_color: "",
      file_stnk: "",
      file_kir: "",
      file_truck: "",
      tag: "",
      kir: {
        no: "",
        exp: "",
        img: ""
      },
      stnk: {
        no: "",
        exp: "",
        img: ""
      },
      truck: {
        no: "",
        exp: "",
        img: ""
      }
    },
    isLoading: false,
    columns_mutation: [
      { 
        key: 'type',
        label: 'Status',
      },
      {
        key: 'date_start',
        label: 'Start Date',
      },
      {
        key: 'date_end',
        label: 'End Date',
      },
      {
        key: 'curr_own',
        label: 'Current',
      },
      {
        key: 'prev_own',
        label: 'Previous',
      },
      {
        key: 'actions',
        label: 'Actions',
      },
    ],
    columns: [
      {
        key: 'license_place',
        label: 'Plate',
      },
/*
      {
        key: 'owner_name',
        label: 'Owner',
      },
      {
        key: 'paint_color',
        label: 'Color',
      },
 */
      {
        key: 'model_color',
        label: 'Model',
      },
      {
        key: 'expiry',
        label: 'Expiry',
      },
      {
        key: 'KIR',
        label: 'KIR',
      },
      {
        key: 'STNK',
        label: 'STNK',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'actions',
        label: 'Actions',
      },
    ],
    pagination: {
      current: 1,
      last_page: 15,
      total_items:0,
      per_page: 10,
      at_last_page: false,
    },
    status: [
      {
        0: 'danger', 1: 'primary',
      },
      {
        0: 'Disable', 1: 'Enable',
      }
    ],
    type: {
      2: 'Truck',
      3: 'STNK',
      4: 'KIR',
    },
    activatedVehicle: {
      lic_plate: '',
      payment_no: '',
      expire_date: '',
      status: 1,
    },
    disabledVehicle: {},
    searchForm: {
      keywords: null,
      type: null,
      status: 1,
      expire: '1970-01-01', // default today
    },
    doc: {
      member: 0,
      id: 0,
      type: 0,
      no: '',
      exp: '',
      file: '',
    },
    options: {
      search: [
        {text: '', value: ''},
        {text: 'License Plate', value: 'lic_plate'},
        {text: 'Color', value: 'paint_color'},
        {text: 'Model', value: 'brand_model'},
      ],
      pagination: [
        10,
        20,
        30,
        40,
        50,
        80,
        100,
      ],
      status: [
        {text: 'Inactive', value: 0},
        {text: 'Active', value: 1},
      ],
    },
    file: {
      stnk: null,
      kir: null,
      truck: null,
    },
    readOnly: false,
    image: {
      center: true,
      fluidGrow: false,
      width: 150,
      height: 150,
      class: 'mb-3',
      thumbnail: true,
    },
    btn_register: true,
  }),
  methods: {
    async loadPage(ctx) {
      this.isLoading = true;
      this.pagination.at_last_page = false;
      this.pagination.total_item = 0;
      try {
        const {data: {data: {rows}}} = await listVehicle(this.searchParams(ctx));
        this.isLoading = false;
        const vehicles = Array.isArray(rows.vehicle) ? rows.vehicle : [rows.vehicle];
        this.pagination.total_items = vehicles.length
        this.pagination.at_last_page = this.pagination.total_items < this.pagination.per_page;

        // get list rfid tag add to vehicle state.
        const rfid_list = JSON.parse(await listTag()).rsp;
        vehicles.forEach((veh) => {
          Object.assign(veh, {tag: "STID Unregistered."});
          rfid_list.forEach((rf) => {
            if(veh.truck.no == rf.no_pol){
              Object.assign(veh, {tag: rf.tag});
            }
          });
        });
        
        return vehicles;
      } catch (e) {
        this.isLoading = false;
        this.pagination.at_last_page = true;
        return [];
      }
    },
    clickSign(){
      this.btn_register = !this.btn_register;
    },
    async confirmRfid(v){
      this.isSubmitting = true;
      const regTag = JSON.parse( await registerTag(v));
      
      if(regTag.status == 'success'){
        this.isSubmitting = false;
        this.btn_register = !this.btn_register;
        this.$bvModal.hide('confirmation-rfid');

        //this.clearForm();
        //this.$refs.table.refresh();

        this.$bvToast.toast(`STID succeesfully Integrated.`, {
          title: 'Registered.',
          autoHideDelay: 3000,
          variant: 'success',
        })
      }else{
        this.isSubmitting = false;
        this.$bvModal.hide('confirmation-rfid');
        this.$bvToast.toast(`something went wrong.`, {
          title: 'Failed.',
          autoHideDelay: 3000,
          variant: 'danger',
        })
      }
    },
    cancelSign(){
      this.btn_register = !this.btn_register;
    },
    async loadMutation(){
      const index_mutation = await indexMutation({
        no_pol:this.vehicle.truck.no
      });
      
      let index = JSON.parse(index_mutation).data;
      
      return index;
    },
    async updateDoc() {
      if (!this.can('superadmin|gate_pass')) {
        this.$bvToast.toast(`Unauthorized Access!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      if (!this.doc.file) {
        this.$bvToast.toast(`Lengkapi dengan Foto / Gambar`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      try {
        this.isSubmitting = true;
//        this.doc.no = Str.removeAllWhitespaces(this.doc.no);
        if (this.doc.file) {
          if (this.doc.file.size > 1_000_000) {
            this.$bvToast.toast(`Foto / Gambar terlalu besar! Max 1MB`, {
              title: 'Error!',
              autoHideDelay: 1500,
              variant: 'danger',
            })
            this.isSubmitting = false;
            return;
          }
          let img = await this.uploadImage(this.doc.file)
          if( this.doc.type == 2 ) {
            await setImgDoc({
              member: this.doc.member,
              file_id: this.doc.id,
              type: this.doc.type,
              file: img,
            })
          } else {
            await setImgDoc({
              member: this.doc.member,
              file_id: this.doc.id,
              type: this.doc.type,
              file: img,
              no: this.doc.no,
              expire: this.doc.exp,
            })
          }
          switch ( this.doc.type ) {
            case 2:
              this.vehicle.truck.img = img;
              break;
            case 3:
              this.vehicle.stnk.img = img;
              this.vehicle.stnk.no = this.doc.no;
              this.vehicle.stnk.exp = this.doc.exp;
              break;
            case 4:
              this.vehicle.kir.img = img;
              this.vehicle.kir.no = this.doc.no;
              this.vehicle.kir.exp = this.doc.exp;
              break;
          }
          this.$bvToast.toast(`${this.doc.no} document updated!`, {
            title: 'Congratulation!',
            autoHideDelay: 1500,
            variant: 'success',
          })
          this.$bvModal.hide('imgDocModal');
          this.$bvModal.hide('vehicleModal');
        }
        this.doc.id = 0;
        this.doc.type = 0;
        this.doc.no = '';
        this.doc.exp = '';
        this.pagination.current = 1;
        this.$v.editDoc.$reset();
        this.$refs.table.refresh()
      } catch (e) {
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
        }
      }
      this.isSubmitting = false;
    },
    async submitVehicle() {
//      console.log(this.file.stnk)
      this.$v.vehicle.$touch();
      if (this.$v.vehicle.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      if (!this.file.stnk || !this.file.kir || !this.file.truck) {
        this.$bvToast.toast(`Lengkapi gambar Truk, STNK & KIR `, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      try {
        this.isSubmitting = true;
        //removing all white spaces
        this.vehicle.no_pol = Str.removeAllWhitespaces(this.vehicle.no_pol);
        this.vehicle.stnk.no = Str.removeAllWhitespaces(this.vehicle.stnk.no);
        this.vehicle.kir.no = Str.removeAllWhitespaces(this.vehicle.kir.no);
        this.vehicle.truck.no = Str.removeAllWhitespaces(this.vehicle.truck.no);
        if (this.file.stnk) {
          if (this.file.stnk.size > 1_000_000) {
            this.$bvToast.toast(`Gambar STNK terlalu besar! Max 1MB`, {
              title: 'Error!',
              autoHideDelay: 1500,
              variant: 'danger',
            })
            return;
          }
          this.vehicle.stnk.img = await this.uploadImage(this.file.stnk)
        }
        if (this.file.kir) {
          if (this.file.kir.size > 1_000_000) {
            this.$bvToast.toast(`Gambar KIR terlalu besar! Max 1MB`, {
              title: 'Error!',
              autoHideDelay: 1500,
              variant: 'danger',
            })
            return;
          }
          this.vehicle.kir.img = await this.uploadImage(this.file.kir)
        }
        if (this.file.truck) {
          if (this.file.truck.size > 1_000_000) {
            this.$bvToast.toast(`Gambar TRUCK terlalu besar! Max 1MB`, {
              title: 'Error!',
              autoHideDelay: 1500,
              variant: 'danger',
            })
            return;
          }
          this.vehicle.truck.img = await this.uploadImage(this.file.truck)
        }
        await addVehicle(this.vehicle);
        this.$bvToast.toast(`Add Vehicle Success!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.clearForm();
        this.$bvModal.hide('vehicleModal')
        this.pagination.current = 1;
        this.$refs.table.refresh()
      } catch (e) {
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
      this.isSubmitting = false;
    },
    clearForm() {
      this.vehicle = {
        member: 0,
        no_pol: "",
        owner_name: "",
        brand_model: "",
        paint_color: "",
        file_stnk: "",
        file_kir: "",
        file_truck: "",
        tag:"",
        kir: {
          no: "",
          exp: "",
          img: ""
        },
        stnk: {
          no: "",
          exp: "",
          img: ""
        },
        truck: {
          no: "",
          exp: "",
          img: ""
        }
      }
      this.readOnly = false;
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async updateVehicleStatus(vehicle) {
      if (!this.can('superadmin|gate_pass')) {
        this.$bvToast.toast(`Unauthorized Access!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.$v.activatedVehicle.$touch();
      if (this.$v.activatedVehicle.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.isSubmitting = true;
      try {
        await activateVehicle(vehicle)
        this.$bvToast.toast(`${vehicle.lic_plate} Status Updated!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.isSubmitting = false;
        this.activatedVehicle = {
          lic_plate: '',
          payment_no: '',
          expire_date: '',
          status: 1,
        }
        this.$bvModal.hide('activate')
        this.pagination.current = 1;
        this.$v.activatedVehicle.$reset();
        this.$refs.table.refresh()
      } catch (e) {
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
      this.isSubmitting = false;
    },
    setVehicleMember(member) {
      this.vehicle.owner_name = member.company_name;
      this.vehicle.member = member.id;
      this.$v.vehicle.owner_name.$touch();
    },
    openVehicleModal() {
      if (!this.isSuperAdmin) {
        this.setVehicleMember(this.member)
      }
      this.$bvModal.show('vehicleModal')
    },
    openImgDocModal( type ) {
        this.doc.member = this.vehicle.member;
        this.doc.type = type;
        this.doc.id = this.vehicle.file_id;
        switch (type) {
          case 3:
            this.doc.no = this.vehicle.stnk.no;
            this.doc.exp = this.vehicle.stnk.exp;
            break;
          case 4:
            this.doc.no = this.vehicle.kir.no;
            this.doc.exp = this.vehicle.kir.exp;
            break;
        }
        this.$bvModal.show('imgDocModal');
    },
    showConfirmationModal(vehicle) {
      if (!vehicle.status) {
        this.activatedVehicle.lic_plate = vehicle.lic_plate;
        this.$bvModal.show('activate');
      } else {
        this.disabledVehicle = vehicle;
        this.$bvModal.show('confirmation');
      }
    },
    async disableVehicle(vehicle){
      if (!this.can('superadmin|gate_pass')) {
        this.$bvToast.toast(`Unauthorized Access!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      this.isSubmitting = true;
      await activateVehicle({
        lic_plate: vehicle.lic_plate,
        status: 0,
      })
      this.$bvToast.toast(`${vehicle.lic_plate} Status Disabled!`, {
        title: 'Congratulation!',
        autoHideDelay: 1500,
        variant: 'success',
      })
      this.$bvModal.hide('confirmation')
      this.isSubmitting = false;
      this.pagination.current = 1;
      this.$refs.table.refresh();
    },
    async delMutation(vhc){
      if(
        JSON.parse(
          await delMutation(vhc)).status == 'success'){
            this.$bvModal.hide('AddMutationModal');
        this.$bvModal.hide('vehicleMutationModal');
        this.$bvModal.hide('vehicleModal');

        this.clearForm();
        this.pagination.current = 1;
        this.$refs.table.refresh();
        this.$refs.tableMutation.refresh();

        this.$bvToast.toast(`Ownership Deleted.`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
      }
    },
    async addMutation(){
      // console.log('member_end',this.vehicle.member);
      // console.log('member_own',this.selectedMember.id);
      let payload = {
        member_end:this.vehicle.member,
        member_own:this.selectedMember.id,
        no_pol:this.vehicle.truck.no,
      };

      const rsp_addMutation = await addMutation(payload);
      
      payload.member_end = '';
      payload.member_own = '';
      payload.no_pol = ''
      if(JSON.parse(rsp_addMutation).status == 'success'){
        this.$bvModal.hide('AddMutationModal');
        this.$bvModal.hide('vehicleMutationModal');
        this.$bvModal.hide('vehicleModal');

        this.clearForm();
        this.pagination.current = 1;
        this.$refs.table.refresh();
        this.$refs.tableMutation.refresh();

        this.$bvToast.toast(`Ownership Successfully Changes!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
      }
    },
    searchParams(ctx) {
      const searchData = {
        per_page: this.pagination.per_page,
        current_page: this.pagination.current,
        status: 0,
      };
//      this.$bvToast.toast(`MEMBER `+this.selectedMember, {
//        title: 'Error!' + this.searchForm.expire,
//        autoHideDelay: 1500,
//        variant: 'danger',
//      })
      if (ctx.sortBy != '') {
        const direction = ctx.sortDesc ? 'desc': 'asc';
        searchData['order_by'] = `${ctx.sortBy},${direction}`;
      }
      if (this.searchForm.type) {
        searchData[this.searchForm.type] = `${this.searchForm.keywords}`;
      }
      if (this.searchForm.status) {
        searchData['status'] = this.searchForm.status;
      }
      if (this.selectedMember !== null) {
        searchData['member'] = this.selectedMember.id
      }
      if (this.searchForm.expire !== '1970-01-01') {
        searchData['expire'] = this.searchForm.expire;
      }
      return searchData;
    },
    isString(x) {
      return isString(x);
    },
  },
  created() {
    this.interval = setInterval(() => {
      // Concise way to format time according to system locale.
      // In my case this returns "3:48:00 am"
      this.time = Intl.DateTimeFormat(navigator.language, {
        day: '2-digit',
        month:'2-digit',
        year:'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      }).format()
    }, 1000)
  },
  mounted() {
  }
}
</script>

<style scoped>
  .cursor-pointer{
    cursor: pointer;
  }
</style>
